const values = {
    "PENDING_INVOICES_TITLE": "Facturas pendientes por pagar",
    "NO_PENDING_INVOICE_TITLE": "No hay facturas por pagar",
    "NO_PENDING_INVOICE_SUBTITLE": "Las facturas pendientes por pagar aparecerán aquí",
    "TOTAL_SALES_TITLE": "Total de ventas",
    "AMOUNT_SERVICES_TITLE": "Total de ventas por servicios",
    "SERVICE_COUNT": "cantidad",
}

export default values;